var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 24,
  fill: "none",
  viewBox: "0 0 35 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.548 17.065V6.935L22.452 12zM33.353 3.748A4.28 4.28 0 0 0 30.34.717C27.685 0 17.032 0 17.032 0S6.38 0 3.724.717a4.28 4.28 0 0 0-3.012 3.03C0 6.422 0 12 0 12s0 5.578.712 8.252a4.28 4.28 0 0 0 3.012 3.032C6.38 24 17.032 24 17.032 24s10.653 0 13.31-.716a4.28 4.28 0 0 0 3.01-3.032c.713-2.674.713-8.252.713-8.252s0-5.579-.712-8.252"
})));
export default SvgYoutube;